import stationImg from '@/assets/img/views/map/station.svg';
import carNormal1 from '@/assets/img/views/map/car_normal_1.svg'; // 配送车ICON
import carNormal2 from '@/assets/img/views/map/vehicle.svg'; // 售卖车ICON
import carAlarm1 from '@/assets/img/views/map/car_alarm_1.svg';
import carAlarm2 from '@/assets/img/views/map/vehicle_alarm.svg';
import stopIcon from '@/assets/img/views/map/stop.svg';
import endPoint from '@/assets/img/views/map/end_point.svg';
import city_xs from '@/assets/img/views/map/city_xs.png';
import city_s from '@/assets/img/views/map/city_s.png';
import city_m from '@/assets/img/views/map/city_m.png';
import city_l from '@/assets/img/views/map/city_l.png';

export {
  stationImg,
  stopIcon,
  endPoint,
  carNormal1,
  carNormal2,
  carAlarm1,
  carAlarm2,
  city_xs,
  city_s,
  city_m,
  city_l,
};

export const getCityIcon = (totalNum: number) => {
  if (totalNum >= 0 && totalNum < 20) {
    return SizeEnum.SIZE_XS;
  }
  if (totalNum >= 20 && totalNum < 50) {
    return SizeEnum.SIZE_S;
  }
  if (totalNum >= 50 && totalNum < 100) {
    return SizeEnum.SIZE_M;
  }
  if (totalNum >= 100) {
    return SizeEnum.SIZE_L;
  }
  return SizeEnum.SIZE_XS;
};

export const SizeEnum = {
  SIZE_XS: city_xs,
  SIZE_S: city_s,
  SIZE_M: city_m,
  SIZE_L: city_l,
};

export const getOffsetTop = (size: string) => {
  switch (size) {
    case SizeEnum.SIZE_XS:
      return -20;
    case SizeEnum.SIZE_S:
      return -30;
    case SizeEnum.SIZE_M:
      return -40;
    case SizeEnum.SIZE_L:
      return -50;
  }
};

/**
 * 获取城市图标尺寸（用于百度 GL BMapGL.Icon）
 * 尺寸与实际 PNG 图标文件保持一致：xs=24, s=40, m=50, l=60
 */
export const getCityIconSize = (size: string) => {
  switch (size) {
    case SizeEnum.SIZE_XS:
      return { width: 24, height: 24 };
    case SizeEnum.SIZE_S:
      return { width: 40, height: 40 };
    case SizeEnum.SIZE_M:
      return { width: 50, height: 50 };
    case SizeEnum.SIZE_L:
      return { width: 60, height: 60 };
    default:
      return { width: 24, height: 24 };
  }
};
